$(document).ready(function() {
	let addToCartPosition = $('.o-add-to-cart__button').offset().top;
	let vpHeight = $(window).height() / 2;

	var windowWidth = $(window).width();


    if (windowWidth > 749) {
		var lastScrollTop = addToCartPosition + 10;
    } else {
    	var lastScrollTop = addToCartPosition + 100;
    }

	
	$(window).scroll(function(event){
		var st = $(this).scrollTop();
		if (st > lastScrollTop){
		  $('.fixed-top-button').addClass('show');
		} else {
		  $('.fixed-top-button').removeClass('show');
		  /*$('#pushdaddy-button').css({'bottom': '10px !important'});*/
		}
	});

	var $root = $('html, body');
	$('.fixed-top-button').click(function () {
	    $root.animate({
	        scrollTop: $('.o-add-to-cart__button').offset().top - 300
	    }, 500);

	    return false;
	});
}); 